<template>
  <div
    class="regulatory-contract"
    v-loading="isLoading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeMethod="changeMethod"
    >
    </SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :columns="columnList"
        :rowStyle="rowStyle"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="seq" title="序号" width="50" align="center"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'overdueFlag'">{{
              row[item.field] == '1' ? '是' : '否'
            }}</template>
            <template v-else-if="item.field === 'contractStatus'">{{
              translateStatus(row.contractStatus)
            }}</template>
            <template v-else-if="item.field === 'alterType'">
              <span v-if="row[item.field] == '01'">一次预警</span>
              <span v-else-if="row[item.field] == '02'">二次预警</span>
              <span v-else-if="row[item.field] == '03'">到期预警</span>
            </template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <OverdueSettingDialog ref="overdueSettingDialogRef" @refreshTable="refreshTable" />
  </div>
</template>

<script>
  import { searchFormColumns, baseColumnListDefault } from './index.js';
  import superviseOverdueDayContractApi from '@/api/park/superviseOverdueDayContract.js';
  import OverdueSettingDialog from './components/OverdueSettingDialog/index.vue';
  import superviseContractMixin from './../superviseContractMixin.js';
  export default {
    name: 'SuperviseContractOverdue',
    mixins: [superviseContractMixin],
    data() {
      return {
        columnList: [],
        tableData: [],
        loading: false,
        menuButtonList: [],
        query: {
          pledgeeNo: '',
          pledgorNo: '',
          relatedNo: '',
          parkCompanyNo: '',
          overdueFlag: '',
          contractNo: '',
          contractValidFrom: '',
          contractValidUntil: '',
          lastPaymemtTime: '',
          alterType: '',
          contractStatus: '',
        },

        parkCompanyName: '',
        pledgeeName: '',
        pledgorName: '',
        relatedName: '',
        contractStatusList: [],
        selectionList: [],
        isLoading: false,
        formData: {}, // 配置信息
        // contractCompanyList: [], // 园区公司下拉框
      };
    },
    computed: {
      searchColumns() {
        return searchFormColumns(this);
      },
    },
    mounted() {
      this.contractStatusList = this.dictListMap.SuperviseContractStatusType;
      // this.contractCompanyList = this.dictListMap.SuperviseContractCompany;
      this.getButtonList();
      this.getTableData();
      this.getHistorySetting();
    },
    methods: {
      //行项目样式
      rowStyle({ row }) {
        const alterType = row.alterType;
        if (alterType == '01') {
          return {
            backgroundColor: this.formData['firstWarnColor'] || '#e6a23c',
            color: '#fff',
          };
        } else if (alterType == '02') {
          return {
            backgroundColor: this.formData['secondWarnColor'] || '#FF6633',
            color: '#fff',
          };
        } else if (alterType == '03') {
          return {
            backgroundColor: this.formData['expiredColor'] || '#f56c6c',
            color: '#fff',
          };
        }
      },
      // 搜索
      searchBtnClick() {
        this.getTableData();
      },
      // 翻译表格状态 contractStatusList
      translateStatus(status) {
        return this.contractStatusList.find((item) => item.value == status)?.label;
      },
      // 重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.idList = [];
        this.getTableData();
      },
      handleSelectionChange(row) {
        this.selectionList = row;
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(baseColumnListDefault).then((res) => {
          console.log(res);
          // TODO 需求确认是否要做隐藏列
          this.columnList = baseColumnListDefault;
        });
      },
      chooseClick(type) {
        console.log(type);
        if (!this.isCheckCurrentCompanyBelongParkCompany()) {
          this.$message.error('当前公司不支持该操作');
          return;
        }
        try {
          this[type]();
        } catch (e) {
          console.error(e);
          this.$message.error(`${type}当前方法不支持,请联系开发人员`);
        }
      },
      refreshTable() {
        this.getHistorySetting();
        this.resetBtnClick();
      },
      async getHistorySetting() {
        const { data } = await this.$axios.post(
          superviseOverdueDayContractApi.GET_HISTORY_SETTING,
          {
            parkCompanyNo: this.userInfo.companyCode,
          }
        );
        if (data.code == 0 && data.data) {
          const {
            expiredColor,
            firstWarnColor,
            firstWarnTip,
            secondWarnColor,
            secondWarnTip,
            parkCompanyNo,
            parkCompanyName,
            contractType,
          } = data.data;
          this.formData = {
            ...this.formData,
            expiredColor,
            firstWarnColor,
            firstWarnTip,
            secondWarnColor,
            secondWarnTip,
            parkCompanyNo,
            parkCompanyName,
            contractType,
          };
        }
      },
      // 配置
      settingHandler() {
        this.$refs.overdueSettingDialogRef.openDialog(this.formData);
      },
      // 导出
      async exportHandler() {
        const idList = this.selectionList.map((item) => item.id);
        if (!idList.length) {
          this.$message.error('选择范围过大，请勾选后数据再导出数据');
          return;
        }
        this.isLoading = true;
        const { data } = await this.$axios.post(superviseOverdueDayContractApi.EXPORT_EXCEL, {
          ids: idList,
        });
        this.isLoading = false;
        if (data.code === 0) {
          window.location.href = data.data;
          this.$message.success('导出成功');
        } else {
          this.$message.error('导出失败');
        }
      },
      //双击事件
      dblclickEvent({ row }) {
        console.log(row, '双击一行');
        if (!this.isCheckCurrentCompanyBelongParkCompany()) {
          this.$message.error('当前公司不支持该操作');
          return;
        }
        const { contractStatus, contractNo, id } = row;
        console.log(row, '双击行', contractStatus, contractNo, id);
        const name = 'detail';
        const path = {
          path: `/park/superviseContract/${name}`,
          name: name,
          meta: {
            keepAlive: false,
            title: '监管合同维护',
          },
          query: {
            status: 'detail',
            contractNo: contractNo ? contractNo : '',
            id,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 表单中事件
      changeMethod({ val, prop }) {
        console.log(val, prop, '触发');
        const selectRowData = (val && val[0]) || {};
        if (prop == 'pledgeeNo') {
          this.query.pledgeeNo = selectRowData.partnerCode;
          this.pledgeeName = selectRowData.partnerZhName;
        } else if (prop == 'pledgorNo') {
          this.query.pledgorNo = selectRowData.partnerCode;
          this.pledgorName = selectRowData.partnerZhName;
        } else if (prop == 'relatedNo') {
          this.query.relatedNo = selectRowData.partnerCode;
          this.relatedName = selectRowData.partnerZhName;
        }
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
      async getTableData() {
        if (!this.isCheckCurrentCompanyBelongParkCompany()) {
          this.$message.error('当前公司不支持该操作');
          this.isLoading = false;
          return;
        }
        console.log('获取表单数据');
        this.isLoading = true;
        const postData = {
          ...this.query,
          parkCompanyNo: this.userInfo.companyCode,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
        };
        const {
          data: { code, data },
        } = await this.$axios.post(superviseOverdueDayContractApi.QUERY_TABLE, postData);
        this.isLoading = false;
        if (code == 0) {
          this.$refs.siruiTable.setPageTotal(data?.total || 0);
          this.tableData = Object.freeze(data?.records) || [];
        } else {
          this.$message.error('查询表格数据失败');
          this.$refs.siruiTable.setPageTotal(0);
          this.tableData = [];
        }
      },
    },
    components: {
      OverdueSettingDialog,
    },
  };
</script>

<style lang="scss" scoped></style>
